/**
 * Same-origin product API prefix. Caddy (and the Vite dev proxy) rewrite
 * `/api/*` → `/wsr-api`. The value is the constant `/api` — never an `api.`
 * host and never `/wsr-api` in the bundle.
 */
export const API_PREFIX = '/api';

export function apiBase(): string {
  return API_PREFIX;
}
